import { useState } from "react";

import { ButtonBase, Grid, Typography } from "@mui/material";

import cloneDeep from 'lodash/cloneDeep';

import { GroceryList } from "../../../app/commonSelector";
import { groceryListIdSelector } from "../../../app/groceryList/groceryList.slice";
import { useAppSelector } from "../../../app/store/hooks";
import useUpdateGroceryList from "../../../hooks/groceryList/useUpdateGroceryList";
import useLogRecipeEdit from "../../../hooks/useLogRecipeEdit";
import { DeleteIcon } from "../../../iconRef/mealPLanIcons";
import Loader from "../../../pages/mealPlan/Loader";
import { EventLogsEnum } from "../../../utils/events";
import UnitDisplay from "../../ingredientsPage/unitDisplay";
import styles from './GroceryListCategory.module.css';

const roundOffWeight = (currentWeightScaleValue: any) => {
    if (currentWeightScaleValue) {
        const updatedWeightScaleValue = cloneDeep(currentWeightScaleValue);
        const [numberPart, unitPart] = updatedWeightScaleValue.value.split(' ');
        const roundedNumber = Math.ceil(parseFloat(numberPart));
        updatedWeightScaleValue.value = `${roundedNumber} ${unitPart}`;
        return updatedWeightScaleValue;
    }
    return currentWeightScaleValue;
}

const ListItem = ({ item, refetchGrocery }: { item: any, refetchGrocery: () => Promise<void> }) => {
    const [translateX, setTranslateX] = useState(0);
    const [startX, setStartX] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const { updatingGroceryListFromRemovingIngredient, updateGroceryListFromRemovingIngredient } = useUpdateGroceryList();
    const { logRecipeEdit } = useLogRecipeEdit();
    const groceryListId = useAppSelector(groceryListIdSelector)
    const updatedWeightScaleValue = roundOffWeight(item.weightScaleValue);

    const ingredientSelected = item.ingredientMetadata;
    const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
        const touch = e.touches[0];
        setStartX(touch.clientX);
        setIsDragging(true);
    };

    const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
        if (!isDragging) return;

        const touch = e.touches[0];
        const currentX = touch.clientX;
        const deltaX = currentX - startX;

        let newTranslateX = translateX + deltaX;
        if (newTranslateX > 0) {
            newTranslateX = 0;
        } else if (newTranslateX < -100) {
            newTranslateX = -100;
        }

        setTranslateX(newTranslateX);
        setStartX(currentX);
    };

    const handleTouchEnd = () => {
        setIsDragging(false);
        if (translateX > -100) {
            setTranslateX(0);
        }
    };

    const handleGroceryDelete = async (ingredientId: string) => {
        await updateGroceryListFromRemovingIngredient({ ingredientId });
        await refetchGrocery();

        logRecipeEdit(EventLogsEnum.REMOVED_FROM_GROCERY_LIST, {
            eventData: {
                list_id: groceryListId,
                ingredient_id: ingredientId,

            },
        });
    }
    if (!item) return null

    return (
        <Grid className={styles.item_wrapper}>
            <Grid className={styles.item_container}
                onTouchEnd={handleTouchEnd}
                onTouchMove={handleTouchMove}
                onTouchStart={handleTouchStart}
                style={{
                    zIndex: 2,
                    transform: `translateX(${translateX}px)`,
                    transition: isDragging ? 'none' : 'transform 0.3s ease',
                }}>
                <Grid className={styles.item_details}>
                    <Grid className={styles.item_description}>
                        <Grid className={styles.item_img_container}>
                            <img
                                alt="recipe"
                                className={styles.item_img}
                                src={ingredientSelected?.image}
                            />
                        </Grid>
                        <Typography className={styles.item_name} variant="ingredientText1Outfit">{ingredientSelected?.displayName}</Typography>
                    </Grid>
                    <Grid className={styles.item_amount}>
                        <UnitDisplay ingredient={ingredientSelected} weighScaleAmount={updatedWeightScaleValue} />
                    </Grid>
                </Grid>
            </Grid>
            <ButtonBase
                className={styles.delete_btn}
                onClick={() => handleGroceryDelete(item?.ingredientId)}
            >
                <DeleteIcon />
                <Typography variant='caption4LightOutfit'>Delete</Typography>
            </ButtonBase>
            <Loader loading={updatingGroceryListFromRemovingIngredient} />
        </Grid>
    )
}
const GroceryListCategory = ({ refetchGrocery }: { refetchGrocery: () => Promise<void> }) => {
    const groceryIngredientList = useAppSelector(GroceryList)
    if (!groceryIngredientList) return null;
    return (
        <Grid className={styles.category_container}>

            <Grid className={styles.category_items}>
                {groceryIngredientList.map((listItem, index) => <ListItem item={listItem} key={listItem.ingredientId.concat((index * 12).toString())} refetchGrocery={refetchGrocery} />)}

            </Grid>

        </Grid>
    )
}

export default GroceryListCategory
